import { render, staticRenderFns } from "./lc-editor-stages-controls.vue?vue&type=template&id=d5824988"
import script from "./lc-editor-stages-controls.vue?vue&type=script&lang=js"
export * from "./lc-editor-stages-controls.vue?vue&type=script&lang=js"
import style0 from "./lc-editor-stages-controls.vue?vue&type=style&index=0&id=d5824988&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports